import { WaterRemoveIcon } from './WaterRemoveIcon';

/**
 * author: Colton Wiscombe
 * id 2B0BAF1E-C9B8-42E9-84EB-D095EE2B0C39
 * name water-remove
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-remove.svg
 * tags
 */
export const InkRemoveIcon = WaterRemoveIcon;
export default InkRemoveIcon